/**
 * Host-only helper: must stay in sync with
 * `packages/modules/doubts/web/src/lib/ainaDoubtsReturnWeb.ts` (STORAGE_KEY).
 * Avoids importing `@repo/doubts-web` entry (Vite resolves to stale `dist/`).
 */
const DOUBTS_RETURN_AINA_AGENT_KEY = "doubts_return_aina_agent_v1";

export function setAinaReturnAgentForDoubtsChat(agent: string): void {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.setItem(DOUBTS_RETURN_AINA_AGENT_KEY, agent.trim());
}
